import React from 'react';

const TodoHeader = ({ children }) => {
  return (
    <header>
      {children}
    </header>
  );
};

export { TodoHeader };
